import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import { CHANNEL_CONTROL } from '../../../../../../utils/constantFeatures';

class ChannelControl extends BaseFeature {
    constructor(props) {
        super(props);

        const bvalue = String(Number(this.props.properties[CHANNEL_CONTROL.channel].value).toString(2)).padStart(4, '0');
        this.state = {
            ch1: bvalue[3],
            ch2: bvalue[2],
            ch3: bvalue[1],
            ch4: bvalue[0],
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        const barr = state.ch4 + state.ch3 + state.ch2 + state.ch1;

        this.props.handleChange(CHANNEL_CONTROL.channel, parseInt( barr, 2 ));
    }

    render() {

        return (
            <div>
                <div className="flex-row">
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {'Mask CH1'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={{value:this.state.ch1, info:{name:"ch1"}}}
                                title="Off/On"
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {'Mask CH2'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={{value:this.state.ch2, info:{name:"ch2"}}}
                                title="Off/On"
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {'Mask CH3'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={{value:this.state.ch3, info:{name:"ch3"}}}
                                title="Off/On"
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {'Mask CH4'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={{value:this.state.ch4, info:{name:"ch4"}}}
                                title="Off/On"
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>
                <div>
                    <Card className="card-feature-component" style={{width: '50%'}}>
                        <div className="card-header-feature">
                            {'Warning'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <h5>
                                By activating mask (Mask CHx -&gt; On), disconnected light engines will not be detected by the driver.
                                <br/><br/>
                                When mask is activated with one or more channels, the LED driver may not be compliant to DALI standard any longer. Reason: detection of a total lamp failure (no light) is mandatory according to DALI standard. Activating masks may also violate legal requirements related to emergency lighting.
                                <br/><br/>
                                1-3 channel operation modes: Settings for unused channels will be ignored.
                            </h5>
                        </Card.Body>
                    </Card>

                </div>

            </div>

        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(ChannelControl);
